var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('div',{staticClass:"errors"},_vm._l((_vm.errors),function(error,i){return _c('b-alert',{key:i,attrs:{"show":"10","variant":"danger","fade":""}},[_vm._v("\n    "+_vm._s(_vm.$t(error))+"\n  ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }